var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.src && _vm.src.includes(".svg")
    ? _c(
        "picture",
        { staticClass: "whitespace-normal" },
        [
          _c("BaseImage", {
            attrs: {
              image: _vm.image ? _vm.image : null,
              classes: _vm.classes,
              "custom-scale": _vm.customScale,
              "is-inline": _vm.isInline,
            },
          }),
        ],
        1
      )
    : _c(
        "picture",
        { staticClass: "whitespace-normal" },
        [
          _c("source", {
            attrs: {
              media: "(min-width: 737px)",
              srcset: _vm.webpSrc(),
              type: "image/webp",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(min-width: 416px)",
              srcset: `${_vm.webpSrc(736)} 1x, ${_vm.webpSrc(1472)} 2x`,
              type: "image/webp",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(max-width: 415px)",
              srcset: `${_vm.webpSrc(415)} 1x, ${_vm.webpSrc(830)} 2x`,
              type: "image/webp",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(min-width: 737px)",
              srcset: _vm.pngSrc(),
              type: "image/png",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(min-width: 416px)",
              srcset: `${_vm.pngSrc(736)} 1x, ${_vm.pngSrc(1472)} 2x`,
              type: "image/png",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(max-width: 415px)",
              srcset: `${_vm.pngSrc(415)} 1x, ${_vm.pngSrc(830)} 2x`,
              type: "image/png",
              alt: _vm.alt,
            },
          }),
          _vm._v(" "),
          _c("BaseImage", {
            attrs: {
              image: _vm.image ? _vm.image : null,
              classes: _vm.classes,
              "custom-scale": _vm.customScale,
              "is-inline": _vm.isInline,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }